import styled from 'styled-components';
import {dFlexCenter, mobileMedia} from '../../../globalVariables/GlobalVariables';
import {eyeSection,wrapper as eyeWrapper} from '../../components/eyeHideSection/EyeHideSection.css';
import {btn} from '../../../component/button/btn/Btn.css';
import {dFlexColumnCenter} from '../../../globalVariables/GlobalFlex';
export const wrapper=styled.div`
    ${dFlexCenter};
    padding: 25px;
    gap: 10px;
    >${btn}{
       margin: 0 7px;
    }
      ${eyeSection}{
            width: 20px;
            height: 100%;
            inset-inline-end: 10px;
            ${dFlexCenter}
            top: 0;
      } 
    } 
     ${mobileMedia}{
      ${dFlexColumnCenter};
      ${btn}{
         width: 170px;
      }
      div{
      ${eyeWrapper}{
            width: 170px;
      }
    } 
 }
`;
